Object.defineProperty(exports, '__esModule', {
  value: true
});
var _tslib = require('../../_tslib-1246030c.js');
var enGB = require('date-fns/locale/en-GB');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var enGB__default = /*#__PURE__*/_interopDefaultLegacy(enGB);

/**
 * This file is basically https://github.com/date-fns/date-fns/blob/master/src/locale/en-US/_lib/formatDistance/index.js
 * with the locale object amended
 */
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1m",
    other: "{{count}}m"
  },
  aboutXHours: {
    one: "1h",
    other: "{{count}}h"
  },
  xHours: {
    one: "1h",
    other: "{{count}}h"
  },
  xDays: {
    one: "1d",
    other: "{{count}}d"
  },
  aboutXMonths: {
    one: "1m",
    other: "{{count}}m"
  },
  xMonths: {
    one: "1m",
    other: "{{count}}m"
  },
  aboutXYears: {
    one: "1y",
    other: "{{count}}y"
  },
  xYears: {
    one: "1y",
    other: "{{count}}y"
  },
  overXYears: {
    one: "over 1y",
    other: "over {{count}}y"
  },
  almostXYears: {
    one: "almost 1y",
    other: "almost {{count}}y"
  }
};
var overwrittenLocale = _tslib.__assign(_tslib.__assign({}, enGB__default['default']), {
  formatDistance: function formatDistance(token, count, options) {
    options = options || {};
    var result;
    // Special case to handle weeks
    if (token === "xDays" && count > 6) {
      result = Math.floor(count / 7) + "w";
    } else if (typeof formatDistanceLocale[token] === "string") {
      result = formatDistanceLocale[token];
    } else if (count === 1) {
      result = formatDistanceLocale[token].one;
    } else {
      result = formatDistanceLocale[token].other.replace("{{count}}", count);
    }
    if (options.addSuffix) {
      if (options.comparison > 0) {
        return "in " + result;
      } else {
        return result + " ago";
      }
    }
    return result;
  }
});
exports.overwrittenLocale = overwrittenLocale;